<!-- eslint-disable -->
<template lang="pug">
    div.generator-form__numbers
        cs-checkbox.generator-form__checkbox(
            v-for="combiningDigitCapacity in filteredCombiningDigitCapacities",
            :checked="combiningDigitCapacities.includes(combiningDigitCapacity)",
            :key="combiningDigitCapacityLabels[combiningDigitCapacity]",
            :disabled="combiningDigitCapacities.length === 2 && combiningDigitCapacities.includes(combiningDigitCapacity)"
            @change="changeCombiningDigitCapacities(combiningDigitCapacity)"
        ) {{ combiningDigitCapacityLabels[combiningDigitCapacity] }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            filteredCombiningDigitCapacities: Array,
            combiningDigitCapacityLabels: Object,
            combiningDigitCapacities: Array
        },
        methods: {
            changeCombiningDigitCapacities(combiningDigitCapacity) {
                this.$emit('changeCombiningDigitCapacities', combiningDigitCapacity);
            }
        }
    }
</script>

<style scoped lang="scss">
    .generator-form {
        &__numbers {
            display: flex;
            flex-wrap: wrap;
            @include stack-space($space-x-small);
        }

        &__checkbox {
            @include inline-space($space-base);
        }
    }
</style>